import { AbstractControl, ValidatorFn } from '@angular/forms';

export const validateISIN = (value) => {
    const match = value.match(/^([A-Z]{2})([\dA-Z]{10})$/);

    return !!match;
};

export const isin = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: boolean } => {
        let v: string = control.value;

        if (!v) {
            return null;
        }

        v = v.toUpperCase();

        return validateISIN(v) ? null : { isin: true };
    };
};
